import type { Filter, FilterFieldType } from "~/utils/filter"

// Standard filter popover, scoped to the line fields of this grid. String and
// number types keep the editors generic — the shared enum lookup only knows
// variant metadata, not stores/sizes on allocation lines.
export const LINE_FILTER_FIELDS: FilterFieldType[] = [
  { value: "productName", name: "Product name", type: "string" },
  { value: "packageName", name: "Product package", type: "string" },
  { value: "variantName", name: "Variant name", type: "string" },
  { value: "productId", name: "Product ID", type: "string" },
  { value: "variantId", name: "Variant ID", type: "string" },
  { value: "skuId", name: "SKU ID", type: "string" },
  { value: "size", name: "Size", type: "string" },
  { value: "color", name: "Colour", type: "string" },
  { value: "warehouseName", name: "Source location", type: "string" },
  { value: "storeName", name: "Destination location", type: "string" },
  { value: "storeExternalId", name: "Store ID", type: "string" },
  { value: "market", name: "Market", type: "string" },
  { value: "position", name: "Inventory position", type: "number" },
  { value: "stockStatus", name: "Stock status", type: "string" },
  { value: "rosBasisLabel", name: "ROS basis", type: "string" },
  { value: "rosFallbackLevel", name: "ROS fallback level", type: "number" },
  { value: "recommendedQuantity", name: "Suggested qty", type: "number" },
  { value: "override", name: "Override qty", type: "number" },
  { value: "effective", name: "Final qty", type: "number" },
  { value: "unrestrictedSuggestion", name: "Unrestricted suggestion", type: "number" },
  { value: "daysWithInventory", name: "Days w/ stock", type: "number" },
  { value: "storeStock", name: "Location stock on hand", type: "number" },
  { value: "inTransit", name: "In transit (inbound)", type: "number" },
  { value: "dcStock", name: "WH available to allocate", type: "number" },
  { value: "networkStock", name: "Network stock", type: "number" },
  { value: "valueAtRetail", name: "Value at retail", type: "number" },
  { value: "valueAtCost", name: "Value at cost", type: "number" },
  { value: "on", name: "Included", type: "boolean" },
]
// A line with an override shows even at suggested qty 0, so an excluded line's
// kept override and its warning stay in view. One group: the filter row shows
// OR only between filters of a group.
export const DEFAULT_LINE_FILTERS: Filter[] = [
  { field: "recommendedQuantity", operator: ">", value: "0", values: [], by: "id", groupId: 1 },
  {
    field: "override",
    operator: ">=",
    value: "0",
    values: [],
    by: "id",
    gate: "or",
    groupId: 1,
  },
]

export const lineFilterFieldType = (fields: FilterFieldType[]) => {
  const typeByField = new Map(
    fields.map((field) => [field.dynamicValue ?? field.value, field.type]),
  )
  return (field: string) => typeByField.get(field)
}
